import App from './App';
import jQuery from 'jquery';

const Keys = {
  labelElements: [],

  tabClass: function () {
    // Check for focus and add/remove tab class accordingly
    for (let i = 0, element; (element = this.labelElements[i++]); ) {
      if (document.activeElement === element) {
        element.classList.add('tab');
      } else {
        element.classList.remove('tab');
      }
    }
  },

  setupKeyEvents: function () {
    // Handle keyboard events using jQuery as in the original
    jQuery(document).keyup(function (e) {
      App.keyPress = e.keyCode || e.which;

      // Get the target element
      let $target = jQuery(e.target);

      // Handle Enter key (keyCode 13)
      if (App.keyPress == 13) {
        // Skip age gate with Enter key when focused on skip link
        if (jQuery('#agegate').css('opacity') != '0' && $target.hasClass('skip-main')) {
          App.hideAgeGate();
        }
      }
    });
  },

  /**
   * Fix multiple form labels for ADA compliance
   * This addresses issues with Commerce7 inputs having both ARIA attributes and multiple labels
   */
  fixFormLabels: function () {
    // Setup a mutation observer to watch for Commerce7 elements being added to the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          // Check if any Commerce7 elements were added
          const hasC7Elements = Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === 1 &&
              ((node.id && typeof node.id === 'string' && node.id.includes('c7-')) ||
                (node.className &&
                  typeof node.className === 'string' &&
                  node.className.includes('c7-')) ||
                node.querySelector('[id^="c7-"], [class^="c7-"]'))
          );

          if (hasC7Elements) {
            this.processC7Forms();
            this.fixAriaReferences();
          }
        }
      });
    });

    // Start observing the document
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Run once on page load
    this.processC7Forms();
    this.fixAriaReferences();

    // Also run when the DOM is fully loaded
    jQuery(document).ready(() => {
      this.processC7Forms();
      this.fixAriaReferences();

      // Run again after slick slider initialization
      setTimeout(() => {
        this.fixAriaReferences();
      }, 1000);
    });

    // Additional timeout for delayed slider initialization
    setTimeout(() => {
      this.fixAriaReferences();
    }, 2500);
  },

  /**
   * Process Commerce7 forms to fix multiple labels
   */
  processC7Forms: function () {
    // Find Commerce7 form inputs
    const c7Inputs = document.querySelectorAll('input[id^="c7-"]');

    c7Inputs.forEach((input) => {
      const inputId = input.id;

      // Find all labels associated with this input
      const associatedLabels = document.querySelectorAll(`label[for="${inputId}"]`);

      if (associatedLabels.length > 1) {
        console.log(`Found ${associatedLabels.length} labels for input ${inputId}`);

        // Keep only the first label, convert others to spans
        for (let i = 1; i < associatedLabels.length; i++) {
          const label = associatedLabels[i];
          const span = document.createElement('span');
          span.innerHTML = label.innerHTML;
          span.className = label.className + ' converted-label';
          span.setAttribute('aria-hidden', 'true');

          // Replace the label with the span
          if (label.parentNode) {
            label.parentNode.replaceChild(span, label);
          }
        }
      }

      // Ensure proper aria-labelledby relationship
      if (input.hasAttribute('aria-labelledby')) {
        const labelledById = input.getAttribute('aria-labelledby');
        const ariaLabel = document.getElementById(labelledById);

        if (!ariaLabel) {
          // If the referenced element doesn't exist, use the label text
          const label = document.querySelector(`label[for="${inputId}"]`);
          if (label) {
            input.setAttribute('aria-label', label.textContent.trim());
            input.removeAttribute('aria-labelledby');
          }
        }
      }
    });

    // Fix empty labels or labels with only whitespace
    const allLabels = document.querySelectorAll('label');
    allLabels.forEach((label) => {
      if (!label.textContent.trim()) {
        // If label has no text content, check if it has a meaningful image
        const hasImage = label.querySelector('img[alt]');

        if (!hasImage) {
          // Either add a proper text label or hide it from screen readers
          label.setAttribute('aria-hidden', 'true');

          // If it has a 'for' attribute, ensure the input has proper labeling
          if (label.hasAttribute('for')) {
            const inputId = label.getAttribute('for');
            const input = document.getElementById(inputId);

            if (
              input &&
              !input.hasAttribute('aria-label') &&
              !input.hasAttribute('aria-labelledby')
            ) {
              // Try to find a nearby visible text that could serve as a label
              const nearbyText = this.findNearbyText(input);
              if (nearbyText) {
                input.setAttribute('aria-label', nearbyText);
              }
            }
          }
        }
      }
    });
  },

  /**
   * Fix broken ARIA references in Commerce7 elements
   * Addresses the issue of mismatched IDs and aria-labelledby attributes
   */
  fixAriaReferences: function () {
    // Look for all elements with aria-labelledby attribute
    const elementsWithAriaLabels = document.querySelectorAll('[aria-labelledby]');

    elementsWithAriaLabels.forEach((element) => {
      const labelId = element.getAttribute('aria-labelledby');
      const labelElement = document.getElementById(labelId);

      // If the referenced element doesn't exist, fix it
      if (!labelElement) {
        console.log(`Found broken aria-labelledby reference: ${labelId}`);

        // Look at special case for quantity inputs in Commerce7
        if (labelId.includes('c7-quantity') && labelId.includes('-label')) {
          // Case 1: Input has ID but is referencing a non-existent label
          if (element.id) {
            // Try to find a related label
            const matchingLabel = document.querySelector(`label[for="${element.id}"]`);
            if (matchingLabel) {
              // Set the label ID to match what's expected
              matchingLabel.id = labelId;
              console.log(`Fixed by setting label ID to ${labelId}`);
            } else {
              // If no label found, use aria-label instead
              const nearbyText = this.findNearbyText(element) || 'Quantity';
              element.setAttribute('aria-label', nearbyText);
              element.removeAttribute('aria-labelledby');
              console.log(`Fixed by setting aria-label to "${nearbyText}"`);
            }
          }
          // Case 2: Input has no ID but has aria-labelledby
          else {
            // Generate a proper ID for the input based on its labelledby value
            const baseId = labelId.replace('-label', '');
            element.id = baseId;
            console.log(`Fixed by setting input ID to ${baseId}`);

            // Try to find the label that should be associated with this input
            const matchingLabel = document.querySelector(`label[id=""][for^="c7-quantity"]`);
            if (matchingLabel) {
              // Update the label's for attribute and id
              matchingLabel.setAttribute('for', baseId);
              matchingLabel.id = labelId;
              console.log(`Fixed label for/id to match input ID ${baseId}`);
            } else {
              // If no appropriate label found, convert to aria-label
              element.setAttribute('aria-label', 'Quantity');
              element.removeAttribute('aria-labelledby');
              console.log('Fixed by setting aria-label="Quantity"');
            }
          }
        }
        // General case for other ARIA references
        else {
          // Attempt to find a sensible label based on context
          const nearbyText = this.findNearbyText(element);
          if (nearbyText) {
            element.setAttribute('aria-label', nearbyText);
            element.removeAttribute('aria-labelledby');
            console.log(`Fixed by setting aria-label to "${nearbyText}"`);
          } else {
            // If we can't find a good label, at least don't reference something that doesn't exist
            element.removeAttribute('aria-labelledby');
            console.log('Removed broken aria-labelledby reference');
          }
        }
      }
    });

    // Fix Commerce7 quantity inputs that may have empty IDs
    const emptyIdInputs = document.querySelectorAll('input[id=""]');
    emptyIdInputs.forEach((input) => {
      // Check if this is a Commerce7 quantity input
      if (input.name === 'quantity' && input.closest('.c7-product__add-to-cart')) {
        // Generate a unique ID based on the input's attributes and location
        const uniqueId = 'c7-quantity-' + this.generateUniqueId();
        input.id = uniqueId;
        console.log(`Generated new ID for empty input: ${uniqueId}`);

        // Find the associated label if it exists
        const parentField = input.closest('.c7-form__field');
        if (parentField) {
          const label = parentField.querySelector('label');
          if (label) {
            label.setAttribute('for', uniqueId);
            if (input.hasAttribute('aria-labelledby')) {
              label.id = input.getAttribute('aria-labelledby');
            }
            console.log(`Updated label to match new input ID`);
          }
        }
      }
    });

    // Fix tabindex issues in sliders
    this.fixSliderTabindexIssues();
  },

  /**
   * Fix tabindex issues in slick sliders
   */
  fixSliderTabindexIssues: function () {
    // Find all slick slides that are cloned or not active
    const inactiveSlides = document.querySelectorAll('.slick-slide[aria-hidden="true"]');

    inactiveSlides.forEach((slide) => {
      // Get all focusable elements within the slide
      const focusableElements = slide.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]'
      );

      // Set tabindex to -1 for hidden slides
      focusableElements.forEach((element) => {
        if (element.tagName.toLowerCase() === 'a' || element.tagName.toLowerCase() === 'button') {
          element.setAttribute('tabindex', '-1');
        }

        // Add appropriate aria-hidden for proper screen reader behavior
        element.setAttribute('aria-hidden', 'true');
      });
    });

    // Find active slides and ensure they are properly accessible
    const activeSlides = document.querySelectorAll('.slick-slide.slick-active');
    activeSlides.forEach((slide) => {
      const focusableElements = slide.querySelectorAll('a, button, input');

      // Make elements in active slides focusable
      focusableElements.forEach((element) => {
        // Remove negative tabindex to make them accessible
        if (element.getAttribute('tabindex') === '-1') {
          element.removeAttribute('tabindex');
        }

        // Remove hidden attribute for active slide elements
        element.removeAttribute('aria-hidden');
      });
    });
  },

  /**
   * Generate a unique ID for elements that need one
   */
  generateUniqueId: function () {
    return (
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    );
  },

  /**
   * Find nearby text that could serve as a label for an input
   */
  findNearbyText: function (element) {
    // Look at siblings and parent's children
    const parent = element.parentNode;
    if (!parent) return null;

    // Check siblings
    const siblings = Array.from(parent.children);
    for (const sibling of siblings) {
      if (sibling !== element && sibling.textContent.trim()) {
        // Avoid using very long text blocks
        const text = sibling.textContent.trim();
        if (text.length < 50) {
          return text;
        }
      }
    }

    // Check parent's text content
    const parentText = parent.textContent.trim();
    const directText = Array.from(parent.childNodes)
      .filter((node) => node.nodeType === 3) // Text nodes
      .map((node) => node.textContent.trim())
      .filter((text) => text.length > 0)
      .join(' ');

    if (directText && directText.length < 50) {
      return directText;
    }

    return null;
  },

  init: function () {
    // Get all interactive elements that might need tab class
    this.labelElements = document.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]'
    );

    // Setup keyboard events
    this.setupKeyEvents();

    // Set up focus detection for accessibility
    document.addEventListener('focusin', () => this.tabClass());

    // Fix ADA issues with form labels
    this.fixFormLabels();
  },
};

export default Keys;
